export default __webpack_public_path__ + "static/media/983.e51ea9bc.png";